module.exports = __webpack_public_path__ + "static/avatarwbg-418d4be11b432ac4373bc823682a02ce.png";